// removed by extract-text-webpack-plugin
module.exports = {"root":"Quote__root--fHvPf","styled":"Quote__styled--2BOAA","plain":"Quote__plain--kY7a_","icon":"Quote__icon--322W3","bounce":"Quote__bounce--1A_v3"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Library/Quote/Quote.css
// module id = ./src/components/Library/Quote/Quote.css
// module chunks = 2